import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.match.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import keys from 'lodash/keys';
import { stringify } from 'qs';
import * as types from './types';
import fetchSearch from '~/services/search';
export default {
  fetchContent: function fetchContent(_ref, _ref2) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, keyword, query, withMarketplace, _yield$fetchSearch, productSearch, details, total, products, suggestions, provider, queryID, redirectUrl, currentQuery;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            keyword = _ref2.keyword, query = _ref2.query, withMarketplace = _ref2.withMarketplace;
            if (keyword) {
              _context.next = 7;
              break;
            }
            commit(types.SET_DESCRIPTION, {
              query: ''
            });
            commit(types.SET_PRODUCTS, {
              products: [],
              total: 0
            });
            commit(types.SET_SUGGESTIONS, {
              suggestions: []
            });
            return _context.abrupt("return");
          case 7:
            _context.next = 9;
            return fetchSearch(_this, keyword, query, withMarketplace);
          case 9:
            _yield$fetchSearch = _context.sent;
            productSearch = _yield$fetchSearch.productSearch;
            if (productSearch) {
              _context.next = 16;
              break;
            }
            commit(types.SET_DESCRIPTION, {
              query: keyword
            });
            commit(types.SET_PRODUCTS, {
              products: [],
              total: 0
            });
            commit(types.SET_SUGGESTIONS, {
              suggestions: []
            });
            return _context.abrupt("return");
          case 16:
            details = productSearch.details, total = productSearch.total, products = productSearch.products, suggestions = productSearch.suggestions, provider = productSearch.provider, queryID = productSearch.queryID;
            commit(types.SET_PROVIDER, provider);
            if (!details.redirect) {
              _context.next = 23;
              break;
            }
            redirectUrl = "".concat(details.redirect_to);
            currentQuery = keys(query).length ? "&".concat(stringify(query)) : '';
            if (redirectUrl.match(/^\/[A-Z]{2}\/[a-z]{2}\/(?:c|e|p|q|s)\//)) {
              _this.app.context.redirect(301, "".concat(redirectUrl).concat(currentQuery));
            } else {
              window.location.href = "".concat(redirectUrl).concat(currentQuery);
            }
            return _context.abrupt("return");
          case 23:
            // For Algolia search results, total isn't present in details
            if (!details.total && total) {
              details.total = total;
            }
            commit(types.SET_DESCRIPTION, _objectSpread(_objectSpread({}, details), {}, {
              queryID: queryID
            }));
            commit(types.SET_PRODUCTS, {
              products: products,
              total: total
            });
            commit(types.SET_SUGGESTIONS, {
              suggestions: suggestions
            });
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  appendProducts: function appendProducts(_ref3, _ref4) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, keyword, query, withMarketplace, _yield$fetchSearch2, products;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref3.commit;
            keyword = _ref4.keyword, query = _ref4.query, withMarketplace = _ref4.withMarketplace;
            _context2.next = 4;
            return fetchSearch(_this2, keyword, query, withMarketplace);
          case 4:
            _yield$fetchSearch2 = _context2.sent;
            products = _yield$fetchSearch2.productSearch.products;
            commit(types.APPEND_PRODUCTS, products);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  prependProducts: function prependProducts(_ref5, _ref6) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, keyword, query, withMarketplace, _yield$fetchSearch3, products;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref5.commit;
            keyword = _ref6.keyword, query = _ref6.query, withMarketplace = _ref6.withMarketplace;
            _context3.next = 4;
            return fetchSearch(_this3, keyword, query, withMarketplace);
          case 4:
            _yield$fetchSearch3 = _context3.sent;
            products = _yield$fetchSearch3.productSearch.products;
            commit(types.PREPEND_PRODUCTS, products);
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
};